import dayjs, { type Dayjs } from 'dayjs';
import type { FilterConfig } from '@/components/FilterBar/FilterBar';
import {
  createSearchFilter,
  createSelectFilter,
  createDateRangeFilter,
} from '@/components/FilterBar/builders';
import { CHANNEL_GROUP_OPTIONS, STATUS_GROUP_OPTIONS } from './constants';

export type OrderFilterKey =
  | 'search'
  | 'status_group'
  | 'channel_group'
  | 'date_from'
  | 'date_to';

export const ORDER_FILTER_KEYS: readonly OrderFilterKey[] = [
  'search',
  'channel_group',
  'status_group',
  'date_from',
  'date_to',
] as const;

interface BuildOpts {
  drafts: Record<OrderFilterKey, string>;
  setDraft: (key: OrderFilterKey, value: string) => void;
  onApply: () => void;
}

export function buildOrderFilters({ drafts, setDraft, onApply }: BuildOpts): FilterConfig[] {
  // Range derive từ 2 drafts (date_from + date_to ISO strings) → DatePicker.RangePicker.
  const fromDayjs = drafts.date_from ? dayjs(drafts.date_from) : null;
  const toDayjs = drafts.date_to ? dayjs(drafts.date_to) : null;
  const dateRange: [Dayjs | null, Dayjs | null] | null =
    fromDayjs || toDayjs ? [fromDayjs, toDayjs] : null;

  return [
    createSearchFilter({
      key: 'search',
      label: 'Tìm kiếm',
      placeholder: 'Mã đơn, khách hàng, SĐT...',
      width: 240,
      value: drafts.search,
      onChange: (v) => setDraft('search', v),
      onSearch: onApply,
    }),
    createSelectFilter({
      key: 'channel_group',
      label: 'Kênh',
      placeholder: 'Tất cả kênh',
      width: 160,
      value: drafts.channel_group,
      onChange: (v) => setDraft('channel_group', v),
      options: CHANNEL_GROUP_OPTIONS,
    }),
    createSelectFilter({
      key: 'status_group',
      label: 'Trạng thái',
      placeholder: 'Tất cả',
      width: 140,
      value: drafts.status_group,
      onChange: (v) => setDraft('status_group', v),
      options: STATUS_GROUP_OPTIONS,
    }),
    createDateRangeFilter({
      key: 'date_range',
      label: 'Thời gian',
      width: 240,
      value: dateRange,
      onChange: (range) => {
        setDraft('date_from', range?.[0]?.startOf('day').toISOString() ?? '');
        setDraft('date_to', range?.[1]?.endOf('day').toISOString() ?? '');
        // Date filter apply ngay khi user pick — UX không cần bấm "Áp dụng" thêm.
        onApply();
      },
    }),
  ];
}
